export function dob(value) {
    let number = parseInt(value, 10);
    if (isNaN(number) || number < 1 || number > 9) {
        number = value; // If the value isn't a valid number between 1 and 9, return the original value
    }

    return number;
}